export enum ViewState {
    INITIAL = 'INITIAL',
    LOADING = 'LOADING',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    EMPTY = 'EMPTY',
    OPT_OUT = 'OPT_OUT',
    NO_DATA = 'NO_DATA'
}
